// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonUpdate_wrap__Ihzyy","loader":"ButtonUpdate_loader__w4d3a"};